import FsLightbox from 'fslightbox-react';
import React from 'react';
import { Subscribable } from '../../../libs/subscribable';
import { numArray } from '../../share/helpers/util';

export class Lightbox extends Subscribable<any, any> {
    public state = { toggler: false };

    public render() {
        return <>
            <div onClick={() => this.setState({ toggler: !this.state.toggler })}>
                {this.props.trigger}
            </div>
            <FsLightbox
                toggler={this.state.toggler}
                sources={this.props.photos}
                types={numArray(this.props.photos.length).map(num => 'image')}
            />
        </>;
    }
}
